
export const CHANGE_PAGE = 'CHANGE_PAGE';
export const PLAY = 'PLAY';
export const PAUSE = 'PAUSE';
export const STOP = 'STOP';
export const PREV_SONG = 'PREV_SONG';
export const NEXT_SONG = 'NEXT_SONG';
export const RANDOM_SONG = 'RANDOM_SONG';
export const SELECT_SONG = 'SELECT_SONG';
export const CREATE_SONG = 'CREATE_SONG';
export const UPDATE_SONG = 'UPDATE_SONG';
export const DELETE_SONG = 'DELETE_SONG';

export const PLAYER_TO_LIST = 'PLAYER_TO_LIST';
export const LIST_TO_PLAYER = 'LIST_TO_PLAYER';



// WEBPACK FOOTER //
// ./src/stores/mutation_types.js